// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  align-items: center;
}
:host i.control-icon::before {
  font-size: 2.3rem;
}
:host i.control-icon:hover {
  cursor: pointer;
}
:host input {
  border: none;
  outline: none;
  margin-left: 1rem;
  width: 15rem;
  transition: width 0.2s ease;
}
:host input.hidden {
  width: 0;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./angular/src/app/core/layout/search-input/search-input.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;AAGI;EACE,eAAA;AADN;AAKE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,2BAAA;AAHJ;AAKI;EACE,QAAA;EACA,SAAA;AAHN","sourcesContent":[":host {\n  display: flex;\n  align-items: center;\n\n  i.control-icon {\n    &::before {\n      font-size: 2.3rem;\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  input {\n    border: none;\n    outline: none;\n    margin-left: 1rem;\n    width: 15rem;\n    transition: width 0.2s ease;\n\n    &.hidden {\n      width: 0;\n      margin: 0;\n    }\n  }\n\n  >>> search-input {\n    input {\n      background: transparent;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
